import { useLocation } from "react-router-dom";
import { useLayoutEffect } from "react";
import useReferralEvent from "../../hooks/useReferralEvent";
import useJoinGame from "../../hooks/useJoinGame";

export default function useController() {
  const location = useLocation();
  const { setReferralEvent } = useReferralEvent();
  const { joinGame, isLoading } = useJoinGame();

  const handleReferralLink = async () => {
    const urlSearchParams = new URLSearchParams(location.search);
    const ref = urlSearchParams.get("ref") || "";
    if (!ref || !ref.length) return;
    const formData = {
      ref,
      referer: document.referrer ?? "",
    };
    await setReferralEvent(ref, formData);
  };

  useLayoutEffect(() => {
    handleReferralLink();
    const urlSearchParams = new URLSearchParams(location.search);
    const link = urlSearchParams.get("link") || "";
    joinGame(link);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    isLoading,
  };
}
